<template>
  <iframe src="/tradeCompliance.html"></iframe>
</template>

<script>
export default {
  name: 'tradeCompliance'
}
</script>
<style lang="less" scoped>
iframe {
  width: 100%;
  height: 2000px;
}
</style>
